import React from "react";

// Predicted outcome — combines success% + composition + horde into a range
export const PredictedOutcome = ({ approach, target, tactic, preview, horde, personalForce }) => {
  if (!approach || !target || !tactic || !preview) return null;
  const aSuccess = (approach.success_pct || 50) / 100;
  const tSuccess = (target.success_pct || 50) / 100;
  const cSuccess = (tactic.success_pct || 50) / 100;
  const overall = (aSuccess + tSuccess + cSuccess) / 3;

  const effectiveForce = 1 + (personalForce || 0);
  const baseKills = Math.min(preview.humans || 10, Math.round(effectiveForce * 4 * overall));
  const killsLow = Math.max(1, Math.round(baseKills * 0.7));
  const killsHigh = Math.max(killsLow + 1, Math.round(baseKills * 1.3));

  const convertRate = (target.convert_chance ?? 0.5);
  const convertedLow = Math.round(killsLow * convertRate * 0.85);
  const convertedHigh = Math.round(killsHigh * convertRate * 1.05);

  const wound = (approach.wound_mult || 1) * (tactic.wound_mult || 1);
  const fallenLow = Math.max(0, Math.round(effectiveForce * wound * (1 - overall) * 0.4));
  const fallenHigh = Math.max(fallenLow + 1, Math.round(effectiveForce * wound * (1 - overall) * 1.2));

  const odds = Math.round(overall * 100);
  return (
    <div className="mt-8 narrative-panel max-w-3xl fade-up"
         style={{ borderColor: "var(--blood)", borderWidth: 1 }}
         data-testid="predicted-outcome">
      <div className="flex items-baseline justify-between mb-3">
        <p className="tac-label">PROJECTED OUTCOME</p>
        <span className={`font-mono text-sm tabular-nums ${
          odds >= 60 ? "text-[#7FBA9D]" : odds >= 40 ? "text-bone" : "text-blood"
        }`} data-testid="predicted-odds">
          {odds}% OVERALL
        </span>
      </div>
      <div className="grid grid-cols-3 gap-3 text-xs font-mono">
        <div data-testid="predicted-kills">
          <p className="text-[0.65rem] text-muted-h tracking-wider">EXPECTED KILLS</p>
          <p className="text-bone text-base mt-0.5">{killsLow}–{killsHigh}</p>
        </div>
        <div data-testid="predicted-converted">
          <p className="text-[0.65rem] text-muted-h tracking-wider">CONVERTED</p>
          <p className="text-[#7FBA9D] text-base mt-0.5">{convertedLow}–{convertedHigh}</p>
        </div>
        <div data-testid="predicted-fallen">
          <p className="text-[0.65rem] text-muted-h tracking-wider">YOU MAY LOSE</p>
          <p className="text-blood text-base mt-0.5">{fallenLow}–{fallenHigh}</p>
        </div>
      </div>
      <p className="text-[0.65rem] text-muted-h mt-3 italic leading-relaxed">
        Estimates only. The dice still decide.
      </p>
    </div>
  );
};
